import React, { useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import './AllProjects.css'
import img1 from '../../images/bike-img/Screenshot_1.png'
import img2 from '../../images/bike-img/Screenshot_2.png'
import img3 from '../../images/bike-img/Screenshot_3.png'
import img4 from '../../images/bike-img/Screenshot_37.png'
import img5 from '../../images/health-img/Screenshot_4.png'
import img6 from '../../images/health-img/Screenshot_5.png'
import img7 from '../../images/health-img/Screenshot_6.png'
import img8 from '../../images/health-img/Screenshot_7.png'
import img9 from '../../images/e-shoper/Screenshot_16.png'
import img10 from '../../images/e-shoper/Screenshot_17.png'
import img11 from '../../images/e-shoper/Screenshot_18.png'
import img12 from '../../images/e-shoper/Screenshot_19.png'
import sportimg1 from '../../images/sports-club/img1 (2).png'
import sportimg2 from '../../images/sports-club/img2.png'
import sportimg3 from '../../images/sports-club/img3.png'
import sportimg4 from '../../images/sports-club/img4.png'
import sportimg5 from '../../images/sports-club/img5.png'
import sportimg6 from '../../images/sports-club/img6.png'
import sportimg7 from '../../images/sports-club/img7.png'
import sportimg8 from '../../images/sports-club/img8.png'
import AOS from 'aos'
import 'aos/dist/aos.css';


const AllProjects = () => {
  useEffect( () => {
    AOS.init({
      offset:200,
      duration:200,
      easing:'ease',
    })
  } )
  return (
    <div className='main-black'>
      <u><h2 style={{color:'skyblue'}} >My Projects</h2></u>
        {/* Sports club   */}
      <div className='main'>
        <div className='row mt-2 carousek ' >
   
          <div className='col-md-5 col-lg-5 col-sm-5'  
       >
            <Carousel>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={sportimg1}
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <h3>First slide label</h3> */}
                  {/* <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={sportimg2}
                  alt="Second slide"
                />

                <Carousel.Caption>
                  {/* <h3>Second slide label</h3> */}
                  {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={sportimg3}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={sportimg4}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={sportimg5}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={sportimg6}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={sportimg7}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={sportimg8}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
             
            </Carousel>
          </div>
          <div className='col-md-7 col-lg-7 col-sm-7' 
     >
            <h3 className='project-title' ><u>Sports-Club </u></h3>
            <p className='project-description'>
              This projects is a team projects. There five member made this project

            </p>

            <h4 style={{color:'gold'}}>My Role: I was working to create Dashboard, Front-end UI design, Firebase, and Payment system</h4>

            <div className='project-des'>
              <li>A full-stack (MERN) responsive web application for the Sports-Club </li>
              <li>Login system is done with Firebase and Google sign in use. </li>
              <li> This website is based on Entertainment</li>
              <li>Have admin and user different dashboard</li>
              <li>Admin can make admin also</li>
              <li>This projects have most interesting feature and this feature name is quiz system </li>
              <li>And this project have payment system in ssl-commerce </li>
              <li style={{color:'gold'}}><b className='font-tech'>
                Front-end Technology:
              </b>
                React js, MIUI , React Router, Firebase Authentication , React-redux , toolkit , ssl-commerce</li>
              <li style={{color:'gold'}}><b className='font-tech'>
                Back-end Technology:
              </b >
                Node js,Express js, MongoDB and cors</li>
            </div>



          </div>
          <div className='project-button' >
            <button className='live-btn'><a className='text-dec' href="https://niche-webside.web.app/home">Live Preview </a></button>
            <button className='source-btn'><a className='text-dec' href="https://github.com/nayeem98746/kawasiki-bike-client"> Client-Code</a></button>
            <button className='server-btn'><a className='text-dec' href="https://github.com/nayeem98746/kawasiki-bike-server"> Server-Code</a></button>
          </div>
        </div>
      </div>
      <div className='main'>
        <div className='row mt-2 carousek ' >
   
          <div className='col-md-5 col-lg-5 col-sm-5'  
       >
            <Carousel>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={img1}
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <h3>First slide label</h3> */}
                  {/* <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={img2}
                  alt="Second slide"
                />

                <Carousel.Caption>
                  {/* <h3>Second slide label</h3> */}
                  {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={img3}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={img4}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
          <div className='col-md-7 col-lg-7 col-sm-7' 
     >
            <h3 className='project-title' ><u>Bike Related project </u></h3>
            <p className='project-description'>
              This is an Full-Stack Kawasaki bike family website.User can
              Select bike and order the bike

            </p>


            <div className='project-des'>
              <li>A full-stack (MERN) responsive web application for the Bike </li>
              <li>Login system is done with Firebase and Google sign in use. </li>
              <li> A user can order a bike as he wishes. </li>
              <li>Have admin and user different dashboard</li>
              <li>Admin can make admin also</li>
              <li style={{color:'gold'}}><b className='font-tech'>
                Front-end Technology:
              </b>
                React js, MIUI , React Router, Firebase Authentication</li>
              <li style={{color:'gold'}}><b className='font-tech'>
                Back-end Technology:
              </b >
                Node js,Express js, MongoDB and cors</li>
            </div>



          </div>
          <div className='project-button' >
            <button className='live-btn'><a className='text-dec' href="https://niche-webside.web.app/home">Live Preview </a></button>
            <button className='source-btn'><a className='text-dec' href="https://github.com/nayeem98746/kawasiki-bike-client"> Client-Code</a></button>
            <button className='server-btn'><a className='text-dec' href="https://github.com/nayeem98746/kawasiki-bike-server"> Server-Code</a></button>
          </div>
        </div>
      </div>
      {/* health-care projects */}
      <div className='main'>
        <div className='row mt-2 carousek' >
          <div className='col-md-5 col-lg-5 col-sm-5'  
     >
            <Carousel>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={img5}
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <h3>First slide label</h3>
                  <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={img6}
                  alt="Second slide"
                />

                <Carousel.Caption>
                  {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={img7}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={img8}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
          <div className='col-md-7 col-lg-7 col-sm-7' 
     >
            <h3 className='project-title' ><u>Health Care</u></h3>
            <p className='project-description'>
              This is an Health care website.User can
              Select service and doctor.

            </p>


            <div className='project-des'>
              <li>A  responsive web application for the health care </li>
              <li>Login system is done with Firebase and Google sign in use. </li>
              <li> A user can select the service as he wishes. </li>
              <li>Users can easily use this site because its a one-page website</li>
              <li> All service shows on the home page. So users can easily select their service</li>
              <li style={{color:'gold'}}><b className='font-tech'>
                Front-end Technology:
              </b>
                React js, React-Bootstrap , React Router, Firebase Authentication</li>
              <li style={{color:'gold'}}><b className='font-tech'>
                Back-end Technology:
              </b>
               none</li>
            </div>



          </div>
          <div className='project-button' 
     
    >
            <button className='live-btn'><a className='text-dec' href="https://healthcare-related-websi-edbf0.web.app/">Live Preview </a></button>
            <button className='source-btn'><a className='text-dec' href="https://github.com/nayeem98746/hospital-webside"> Client-Code</a></button>
            {/* <button className='server-btn'><a className='text-dec' href="https://github.com/nayeem98746/kawasiki-bike-server"> Server-Code</a></button> */}
          </div>
        </div>
      </div>
      {/* e-shoper projects */}
      <div className='main'>
        <div className='row mt-2 carousek' >
          <div className='col-md-5 col-lg-5 col-sm-5'  
    >
            <Carousel>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={img9}
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <h3>First slide label</h3>
                  <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={img10}
                  alt="Second slide"
                />

                <Carousel.Caption>
                  {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={img11}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={img12}
                  alt="Third slide"
                />

                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
          <div className='col-md-7 col-lg-7 col-sm-7' 
     >
            <h3 className='project-title' ><u>e-shoper</u></h3>
            <p className='project-description'>
              This is an Full-Stack Kawasaki bike family website.User can
              Select bike and order the bike

            </p>


            <div className='project-des'>
              <li>A full-stack (MERN) responsive web application for the e-commerce related </li>
              <li>Login system is done with Firebase and Google sign in use. </li>
              <li>  User he/she orders the product and then he/she payment in  Nogod, visa card, and Bikash</li>
              <li>Have admin and user different dashboard</li>
              <li>Admin can make admin also</li>
              <li style={{color:'gold'}}><b className='font-tech'>
                Front-end Technology:
              </b>
                React js, MIUI , React Router, Firebase Authentication</li>
              <li style={{color:'gold'}}><b className='font-tech'>
                Back-end Technology:
              </b>
                Node js,Express js, MongoDB and cors</li>
            </div>



          </div>
          <div className='project-button'>
            <button className='live-btn'><a className='text-dec' href="https://e-shoper-238fa.web.app/">Live Preview </a></button>
            <button className='source-btn'><a className='text-dec' href="https://github.com/nayeem98746/e-shoper"> Client-Code</a></button>
            <button className='server-btn'><a className='text-dec' href="https://github.com/nayeem98746/e-shoper-server"> Server-Code</a></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllProjects;